import { render, staticRenderFns } from "./CommunityCreate.vue?vue&type=template&id=e484597e&scoped=true"
import script from "./CommunityCreate.vue?vue&type=script&lang=js"
export * from "./CommunityCreate.vue?vue&type=script&lang=js"
import style0 from "./CommunityCreate.vue?vue&type=style&index=0&id=e484597e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e484597e",
  null
  
)

export default component.exports